/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import { compose, setDisplayName, setPropTypes } from 'recompose'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import BarPlotDisplay from 'compositions/BarPlot'

import barPlotShape from 'shapes/BarPlot'
import barPlotNavigationShape from 'shapes/BarPlotNavigation'
import DocumentNavigationShape from 'shapes/DocumentNavigation'

const BarPlotsTemplate = compose(
  setDisplayName('BarPlotsTemplate'),
  setPropTypes({
    data: PropTypes.shape({
      barPlot: barPlotShape.raw,
      barPlots: barPlotNavigationShape.raw,
      docs: DocumentNavigationShape.raw,
    }),
  })
)(BarPlotDisplay)

export default BarPlotsTemplate

export const query = graphql`
  query($slug: String!) {
    barPlot: imageSharp(fields: { slug: { eq: $slug } }) {
      ...BarPlot
    }

    barPlots: allImageSharp(
      filter: { fields: { plotType: { eq: "Bar" } } }
      sort: { fields: [fields___sortOrder] }
    ) {
      ...BarPlotNav
    }

    docs: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/data/docs/" } }
      sort: { fields: [fields___sortOrder] }
    ) {
      ...DocumentNav
    }
  }
`
